var path = '/app/components/stars/stars.html';
var html = "<ul class=\"list-inline stars\" ng-if=!$ctrl.lg> <li ng-class=\"$ctrl.starsCount >= 1 ? 'star' : 'star-empty'\"></li> <li ng-class=\"$ctrl.starsCount >= 2 ? 'star' : 'star-empty'\"></li> <li ng-class=\"$ctrl.starsCount >= 3 ? 'star' : 'star-empty'\"></li> </ul> <ul class=\"list-inline stars\" ng-if=$ctrl.lg> <li class=lg ng-class=\"$ctrl.starsCount >= 1 ? 'star' : 'star-empty'\"></li> <li class=lg ng-class=\"$ctrl.starsCount >= 2 ? 'star' : 'star-empty'\"></li> <li class=lg ng-class=\"$ctrl.starsCount >= 3 ? 'star' : 'star-empty'\"></li> </ul>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/stars/stars.html
// module id = 157
// module chunks = 0